import { useEffect, useState, useCallback } from "react";
import { getPetOwners } from "../../api/petOwnerService";

export const usePetOwners = (trigger, initialPage = 1, initialLimit = 10) => {
    const [petOwners, setPetOwners] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0 },
        sort: null,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchPetOwners = useCallback(
        async (page = initialPage, limit = initialLimit, append = false, search = searchTerm) => {
        setLoading(true);
        try {
            const response = await getPetOwners(page, limit, search);
            setPetOwners(prev => {
            if (append) {
                return {
                ...response,
                data: [...(prev.data || []), ...response.data],
                };
            }
            // 🔑 Reset pagination when not appending (fresh search or initial load)
            return {
                ...response,
                pagination: { ...response.pagination, page }, 
            };
            });
            return response;
        } catch (err) {
            console.error("Failed to fetch pet owners:", err);
        } finally {
            setLoading(false);
        }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchPetOwners(initialPage, initialLimit, false, searchTerm);
    }, [trigger, fetchPetOwners, initialPage, initialLimit, searchTerm]);

    const loadMore = async () => {
        const nextPage = petOwners.pagination.page + 1;
        if (nextPage <= petOwners.pagination.totalPages) {
        await fetchPetOwners(nextPage, petOwners.pagination.limit, true, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchPetOwners(page, petOwners.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchPetOwners(initialPage, initialLimit, false, "");
    };

    return { petOwners, loading, loadMore, searchFunction, resetParent };
};